import React from 'react';
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { ChevronsLeft } from 'lucide-react';
import styles from '../../pages/UpdatePersonalProfilePage.module.css';

interface UpdateProfileLayoutProps {
  sidebarCollapsed: boolean;
  isHovered: boolean;
  setIsHovered: (hovered: boolean) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  selectedMenuKey: string;
  menuItems: MenuProps['items'];
  onMenuClick: MenuProps['onClick'];
  children: React.ReactNode;
}

export const UpdateProfileLayout: React.FC<UpdateProfileLayoutProps> = ({
  sidebarCollapsed,
  isHovered,
  setIsHovered,
  setSidebarCollapsed,
  selectedMenuKey,
  menuItems,
  onMenuClick,
  children,
}) => {
  return (
    <div className={styles.contentContainer}>
      <div
        className={`${styles.sidebarWrapper} ${sidebarCollapsed ? styles.sidebarCollapsed : ''} ${styles.sidebarWidthTransition}`}
        onMouseEnter={() => {
          setIsHovered(true);
          if (sidebarCollapsed) setSidebarCollapsed(false);
        }}
        onMouseLeave={() => {
          setIsHovered(false);
          if (!sidebarCollapsed && isHovered) setSidebarCollapsed(true);
        }}
      >
        <div className={styles.sidebar}>
          <div className={styles.sidebarHeader}>
            {!sidebarCollapsed && <span className={styles.sidebarTitle}>Menu</span>}
            <ChevronsLeft
              size={16}
              className={`${styles.headerToggleIcon} ${sidebarCollapsed ? styles.iconRotated : ''}`}
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            />
          </div>
          <Menu
            mode="inline"
            selectedKeys={[selectedMenuKey]}
            onClick={onMenuClick}
            items={menuItems}
            className={styles.sidebarMenu}
            inlineCollapsed={sidebarCollapsed}
          />
        </div>
      </div>

      <div className={styles.mainContentWrapper}>
        <div className={styles.mainContent}>{children}</div>
      </div>
    </div>
  );
};

